// extracted by mini-css-extract-plugin
export default {"loder":"Loader_loder__B6wBY"};